import { ApolloLink, from } from "@apollo/client"
import { getCurrentHub } from "@sentry/react"
import type { Span } from "@sentry/types"
import config from "@/v2-backoffice-client/config"

type TraceContext = {
  span?: Span
}

const startLink = new ApolloLink((operation, forward) => {
  const context: TraceContext = operation.getContext()
  const { operationName, variables } = operation

  const hub = getCurrentHub()
  const transaction = hub.startTransaction({
    op: "graphql.request",
    name: operationName,
    description: operationName,
  })

  transaction.setTag("graphql.operationName", operationName)
  transaction.setTag("environment.region", config.region)

  if (variables && Object.keys(variables).length > 0) {
    transaction.setData("graphql.variables", variables)
  }

  hub.getScope().setSpan(transaction)
  context.span = transaction
  operation.setContext(context)
  return forward(operation)
})

const endLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((data) => {
    const { span }: TraceContext = operation.getContext()
    if (span) span.finish()
    return data
  })
})

export const traceLink = from([startLink, endLink])
